import { ChangeEvent, FocusEvent } from 'react'
import { useField } from 'formik'

import DefaultTextField, { DefaultTextFieldProps } from './DefaultTextField'

interface FormikTextFieldProps extends DefaultTextFieldProps {
  name: string
}

export default function FormikTextField({
  helperText,
  onBlur,
  onChange,
  ...props
}: FormikTextFieldProps) {
  const [field, meta] = useField(props.name)
  const showError = Boolean(meta.touched && meta.error)

  return (
    <DefaultTextField
      {...props}
      {...field}
      error={showError}
      helperText={showError ? meta.error : helperText}
      onBlur={(event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        field.onBlur(event)
        onBlur?.(event)
      }}
      onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (!Object.is(event.target.value, field.value)) {
          field.onChange(event)
        }

        onChange?.(event)
      }}
    />
  )
}
